import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getInstalacionesPadreCorralesActivas`, method: 'GET', body: null, token: token})
}